import React from 'react';

export default () => (
    <svg width="12"
        height="12"
        viewBox="0 0 12 12"
        xmlns="http://www.w3.org/2000/svg">
        <path d="M9.75 4.5L11.25 0.75H2.25C2.25 0.3 1.95 0 1.5 0C1.05 0 0.75 0.3 0.75 0.75V11.25C0.75 11.7 1.05 12 1.5 12C1.95 12 2.25 11.7 2.25 11.25V8.25H11.25L9.75 4.5Z"/>
    </svg>
);
